import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import ImpactDashboard from './components/ImpactDashboard';
import AnnualReportsSection from './components/AnnualReportsSection';
import TestimonialsSection from './components/TestimonialsSection';
import GeographicImpactMap from './components/GeographicImpactMap';
import ImpactCalculator from './components/ImpactCalculator';
import RecognitionSection from './components/RecognitionSection';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import Footer from '../../components/ui/Footer';

const ImpactMetricsStories = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Impact - Metrics & Stories | Leo Club of Colombo Circle</title>
        <meta name="description" content="Discover the measurable impact of Leo Club of Colombo Circle through comprehensive metrics, inspiring stories, and community testimonials showcasing our commitment to service excellence." />
        <meta name="keywords" content="Leo Club impact, community service metrics, Colombo youth organization, volunteer impact, community testimonials" />
      </Helmet>

      <Header />

      {/* Hero Section */}
      <section className="pt-24 pb-16 hero-gradient text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center">
            <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-custom rounded-full px-4 py-2 mb-6">
              <Icon name="TrendingUp" size={20} />
              <span className="text-sm font-medium">Measuring Real Impact</span>
            </div>
            
            <h1 className="text-4xl lg:text-6xl font-bold mb-6 text-shadow">
              Impact Through
              <span className="block text-secondary">Metrics & Stories</span>
            </h1>
            
            <p className="text-xl lg:text-2xl text-white/90 max-w-4xl mx-auto mb-8 leading-relaxed">
              Quantifying our community contribution through compelling data visualization and human stories that showcase the real difference we make in Colombo Circle.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                variant="secondary" 
                size="lg"
                className="achievement-gradient hover:opacity-90"
                iconName="BarChart3"
                iconPosition="left"
              >
                View Impact Dashboard
              </Button>
              <Button 
                variant="outline" 
                size="lg"
                className="border-white/30 text-white hover:bg-white/10"
                iconName="FileText"
                iconPosition="left"
              >
                Download Annual Report
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Impact Dashboard */}
      <ImpactDashboard />

      {/* Annual Reports */}
      <AnnualReportsSection />

      {/* Testimonials */}
      <TestimonialsSection />

      {/* Geographic Impact */}
      <GeographicImpactMap />

      {/* Impact Calculator */}
      <ImpactCalculator />

      {/* Recognition & Endorsements */}
      <RecognitionSection />

      {/* Call to Action Section */}
      <section className="py-16 bg-gradient-to-r from-primary to-secondary text-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <Icon name="Heart" size={64} className="mx-auto mb-6 text-white/80" />
          <h2 className="text-3xl lg:text-4xl font-bold mb-6">
            Be Part of Our Impact Story
          </h2>
          <p className="text-xl text-white/90 mb-8 leading-relaxed">
            Join Leo Club of Colombo Circle and contribute to measurable community change. 
            Your leadership journey starts with a single step toward service excellence.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              variant="secondary"
              size="lg"
              className="bg-white text-primary hover:bg-white/90"
              iconName="UserPlus"
              iconPosition="left"
            >
              Join Our Club
            </Button>
            <Button 
              variant="outline"
              size="lg" 
              className="border-white/30 text-white hover:bg-white/10"
              iconName="Calendar"
              iconPosition="left"
            >
              Attend Next Meeting
            </Button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
      
    </div>
  );
};

export default ImpactMetricsStories;